import { render, staticRenderFns } from "./WebPhoneCallHistory.vue?vue&type=template&id=a7af69c0&scoped=true"
import script from "./WebPhoneCallHistory.vue?vue&type=script&lang=js"
export * from "./WebPhoneCallHistory.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneCallHistory.vue?vue&type=style&index=0&id=a7af69c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7af69c0",
  null
  
)

export default component.exports